import { Head, router } from "@inertiajs/react"
import { AboutTest } from "@/components/VocationalTest/AboutTest"

export default function AboutTestPage() {
  return (
    <>
      <Head title="Sobre o teste" />
      <AboutTest onContinue={() => router.visit("/auth-flow")} />
    </>
  )
}
